import '../../styles-new/pages/context/context-article.scss';

import '../components/article-image-slider';
import '../components/share-btn';
import { initializeArticlePopup } from '../components/images-popup';
import { ColumnistDropdown } from '../context/columnist-dropdown';
import { BecomeColumnistPopup } from '../context/become-columnist-popup';

document.addEventListener('DOMContentLoaded', () => {
  initializeArticlePopup(document, document.querySelector('.context-post__container'), true);

  // Initialize all columnist dropdowns
  document.querySelectorAll('.context-select_columnist').forEach(select => {
    new ColumnistDropdown(select);
  });

  // Initialize become columnist popup
  new BecomeColumnistPopup();
});

const breadcrumbsDotsButton = document.querySelector('.breadcrumbs__dots-button');

breadcrumbsDotsButton.addEventListener('click', () => {
  const collapsed = document.getElementById('breadcrumbsCollapsed');
  const expanded = document.getElementById('breadcrumbsExpanded');

  if (collapsed.style.display !== 'none') {
    collapsed.style.display = 'none';
    expanded.style.display = 'flex';
  } else {
    collapsed.style.display = 'flex';
    expanded.style.display = 'none';
  }
});
